// src/components/GenderLegend.tsx
import React from 'react';

const items = [
  { label: 'Male', color: '#0073FF' },
  { label: 'Female', color: '#FF04BC' },
  { label: 'Others', color: '#000000' },
];

export default function GenderLegend() {
  return (
    <div className='flex gap-4 bg-[#F5F5F5] p-[16px] rounded-[16px] border-black border-[1px] text-sm'>
      {items.map((i) => (
        <div key={i.label} className='flex items-center'>
          <span
            className='w-3 h-3 rounded-full mr-1'
            style={{ backgroundColor: i.color }}
          />
          {i.label}
        </div>
      ))}
    </div>
  );
}
